// Cute mascot avatars used in Live Games (leaderboard, reaction ribbon, spectator).
// Emoji-based for zero-asset shipping, animated via Framer Motion / CSS on live events.

export const AVATAR_CATALOG = {
  fox:      { glyph: "🦊", label: "Fox" },
  unicorn:  { glyph: "🦄", label: "Unicorn" },
  panda:    { glyph: "🐼", label: "Panda" },
  cat:      { glyph: "🐱", label: "Cat" },
  dog:      { glyph: "🐶", label: "Dog" },
  koala:    { glyph: "🐨", label: "Koala" },
  frog:     { glyph: "🐸", label: "Frog" },
  monkey:   { glyph: "🐵", label: "Monkey" },
  penguin:  { glyph: "🐧", label: "Penguin" },
  lion:     { glyph: "🦁", label: "Lion" },
  tiger:    { glyph: "🐯", label: "Tiger" },
  pig:      { glyph: "🐷", label: "Pig" },
  rabbit:   { glyph: "🐰", label: "Rabbit" },
  bear:     { glyph: "🐻", label: "Bear" },
  hedgehog: { glyph: "🦔", label: "Hedgehog" },
  octopus:  { glyph: "🐙", label: "Octopus" },
  dragon:   { glyph: "🐲", label: "Dragon" },
  owl:      { glyph: "🦉", label: "Owl" },
  shark:    { glyph: "🦈", label: "Shark" },
  sloth:    { glyph: "🦥", label: "Sloth" },
  phoenix:  { glyph: "🐦‍🔥", label: "Phoenix", legendary: true }, // Creator-only
};

export const AVATAR_IDS = Object.keys(AVATAR_CATALOG);
export const LEGENDARY_IDS = AVATAR_IDS.filter((id) => AVATAR_CATALOG[id].legendary);

export const glyphFor = (id) => (AVATAR_CATALOG[id] || AVATAR_CATALOG.fox).glyph;
export const labelFor = (id) => (AVATAR_CATALOG[id] || AVATAR_CATALOG.fox).label;
